export const OnboardingIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='4.91064'
      y='3.53408'
      width='14.1786'
      height='17.8409'
      rx='1.375'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='1.25'
    />
    <path
      d='M9.42853 10.1818H14.5714'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <path
      d='M9.42853 13.8182H14.5714'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <mask id='path-4-inside-1_2058_1856' fill='white'>
      <rect x='7.71423' y='2' width='8.57143' height='3.63636' rx='1' />
    </mask>
    <rect
      x='7.71423'
      y='2'
      width='8.57143'
      height='3.63636'
      rx='1'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='2.5'
      mask='url(#path-4-inside-1_2058_1856)'
    />
  </svg>
);
